import Modal from "@ui-components/Modal";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import CountryContext from "../../../CountryContext";
import { useContext } from "react";
import {ShowQuotationsModalProps} from "./Resales.type";
import MaterialTable from "@material-table/core";
import TableStyle from "@components/TableStyle";
import { useIntl } from "react-intl";

export const ShowQuotationsModal = ({
  quotations,
  onExit
}:ShowQuotationsModalProps) => {
    const {
    country: {code},
  } = useContext(CountryContext);
  const intl = useIntl();
  const columns = [
    {
      title: '',//intl.formatMessage({id:'quotation', defaultMessage:'Preventivo'}),
      field: 'description',
      render: (rowData: any) => {
        return <div><Link
          to={`/${code}/quotations/${rowData.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ArrowTopRightOnSquareIcon className="inline w-4 -mt-0.5 text-kerakoll-700"/>
        </Link>
          <span className={"ml-2 text-bold"}>{rowData.description}</span>
        </div>
      }
    }
  ]

  const data = quotations.map(quotation => {
    return {
      description: `${intl.formatMessage({id:"quotation", defaultMessage:"Preventivo"})} ${quotation}`,
      id: quotation
    }
  })

  return <Modal
    onExit={onExit}
  >
    <div className={"mt-8"}>
      <TableStyle>
        <MaterialTable
          title={intl.formatMessage({id:'quotations', defaultMessage:'Preventivi'})}
          data={data}
          columns={columns}
          options={{
            paging: true,
            filtering: true,
            sorting: true,
            search: false
          }}
        />
      </TableStyle>
    </div>
  </Modal>
}